
import React, {Component} from 'react'
import getWeb3 from './utils/getWeb3'
import Web3 from 'web3'
import _ from 'lodash';
import variablestore from './variablestore'

import {Link} from "react-router"
import NavLink from './NavLink'

const blockies = require('ethereum-blockies-png')
const gasLimit = 300000
class RegisterEscrowRS extends Component {
	
		constructor(props){
			super(props)

			// eslint-disable-next-line no-undef
			var ETH_CLIENT = new Web3(web3.currentProvider)
			var EscrowMyEtherEntityDB_ABI = variablestore.EscrowMyEtherEntityDB_ABI
			var EscrowMyEtherEntityDB_address = variablestore.EscrowMyEtherEntityDB_address
			var myetherescrowABI = variablestore.myetherescrowABI
			var myetherescrowAddress = variablestore.myetherescrowAddress
			
			this.state = {

				ETH_CLIENT: ETH_CLIENT,
				mee: ETH_CLIENT.eth.contract(myetherescrowABI).at(myetherescrowAddress),
				entitydb: ETH_CLIENT.eth.contract(EscrowMyEtherEntityDB_ABI).at(EscrowMyEtherEntityDB_address),
				accounts: ETH_CLIENT.eth.accounts,
				fromAddress: "",
        		escrowFee: 0,
				
				addressBalance: 0,
				balance: 0,
				withdrawText: "Withdraw Funds",
        		escrowName: "",
				escrowInfo: "",
				callback: "",
			
				popup: false,
				addressBlockie: "",
				feeInfo: "",
				name: "",
				info: ""
			}



		
			this.generateTransaction = this.generateTransaction.bind(this);
			
      		this.handleNameInput = this.handleNameInput.bind(this);
      		this.handleInfoInput = this.handleInfoInput.bind(this);
    
     		this.handleFeeInput = this.handleFeeInput.bind(this);
			this.setFee = this.setFee.bind(this);
		
		
			
			this.clearState = this.clearState.bind(this);
		}
		closePopup() {
			this.setState({				
				popup: false			
			});

		}
		handleNotesInput(e) {
			this.setState({				
				note: e.target.value,			
			});

		}
		clearState() {
			this.resetButtonText()
			this.setState({				
				popup: false,
				addressBalance: 0,
				balance: 0,
				tableRows: [],
				escrowName: "",
				escrowInfo: "",
				escrowFee: 0,
				fromAddress: "",
				addressBlockie: ""
			});

		}
    handleFeeInput(e) {
			if (!isNaN(e.target.value) && e.target.value > 0 && e.target.value <= 10)
			{
						this.setState({fee: e.target.value,
						feeInfo: <p className="small"><font className="green">You will charge {e.target.value}% fee per transaction.</font></p>});		
				
			}
			else
				{
					this.setState({fee: e.target.value,
						feeInfo: <p className="small"><font className="red">Invalid input. Fee must be between 0-10%.</font></p>});
				}
		}
		

	

    handleNameInput(e) {
      this.setState({name: e.target.value});
    }
    handleInfoInput(e) {
      this.setState({info: e.target.value});
    }
  
  
    handleGasInput(e) {
      this.setState({gasLimit: e.target.value});
    }
  
  
    generateTransaction(){
      this.state.entitydb.registerEscrow(this.state.name,this.state.info, {from: this.props.fromAddress, gas: gasLimit}, function(error, result){
				if(!error)
					this.props.newTxCallback(result)
				else
					
					console.log(error)

			}.bind(this))
	}
	


  
    setFee(){
      this.state.mee.setEscrowFee(this.state.fee*10, {from: this.props.fromAddress, gas: gasLimit }, function(error, result){
				if(!error)
					this.props.newTxCallback(result)	
				else
					
					console.log(error)

			}.bind(this))
    }

		
  render() {	
	
    return (
	
		<div>
			
		<h2>Update Escrow Profile</h2>

			<table>
				<tbody>
			<tr>
			<td><p className="left">Your Address: {this.props.fromAddress}</p></td>
			</tr>
			<tr>
			<td><p className="left">Name:</p></td>


			</tr>
			<tr>
			<td><input className="left input-address input-pad" type="text" placeholder="" onChange={this.handleNameInput} value={this.state.name}/></td>

			</tr>

			<tr>
			<td><p className="left">Info:</p></td>

			</tr>
			<tr>
			<td><input className="left input-address input-pad" type="text" placeholder="" onChange={this.handleInfoInput} value={this.state.info}/></td>
			</tr>





			<tr>
			<td colSpan="2"><br/><button className="mainButton" onClick={this.generateTransaction}><h2>Update Profile</h2></button><br/><br/></td>
			</tr>
			</tbody>
			</table>

			<h2>Set Fees</h2>
			<p>Charge a percentage fee in exchange for your escrow services.<br/>Accepted fee range 0.1% - 10%, in increments of 0.1%</p>
			<table>
				<tbody>
			<tr>
			<td><p className="left">Fee (%):</p></td>

			</tr>
			<tr>
			<td><input className="left input-address input-pad" type="text" placeholder="1.5" onChange={this.handleFeeInput} value={this.state.fee}/><br/>
			{this.state.feeInfo}</td>
			</tr>

			<tr>
			<td colSpan="2"><br/><button className="mainButton" onClick={this.setFee}><h2>Set Fees</h2></button><br/><br/></td>
			</tr>
			</tbody>
			</table>
		
		</div>
		

    )
  }
}

export default RegisterEscrowRS;



// WEBPACK FOOTER //
// ./src/RegisterEscrowRS.js